import { CustomAlert } from '@planning/pages/TallymanV2/Components'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

export const NoMatchingAllocationRuleAlert: FC = () => {
  const { t } = useTranslate()
  return (
    <CustomAlert
      message={t(
        'containerDoesNotMatchAllocationRules',
        'Container does not match allocation rules',
      )}
      severity='warning'
    />
  )
}
